/** "189.00" | "189" | 189 | "1,189.50" -> 18900 | 18900 | 18900 | 118950. */
export function toCents(amount) {
    const text = typeof amount === 'number' ? amount.toFixed(2) : amount.replace(/[$,\s]/g, '');
    if (!/^-?\d+(\.\d{1,2})?$/.test(text)) {
        throw new Error(`Invalid money amount: ${String(amount)}`);
    }
    const negative = text.startsWith('-');
    const [whole = '0', fraction = ''] = text.replace('-', '').split('.');
    const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    return negative ? -cents : cents;
}
/** 18900 -> "189.00". */
export function fromCents(cents) {
    if (!Number.isInteger(cents))
        throw new Error(`Cents must be an integer, got ${cents}`);
    const sign = cents < 0 ? '-' : '';
    const abs = Math.abs(cents);
    return `${sign}${Math.floor(abs / 100)}.${String(abs % 100).padStart(2, '0')}`;
}
/** Percentage of an amount, rounded half-up to the nearest cent. */
export function percentOfCents(cents, ratePercent) {
    return Math.round((cents * ratePercent) / 100 + Number.EPSILON);
}
export function sumCents(values) {
    let total = 0;
    for (const value of values)
        total += value;
    return total;
}
/** 18900 -> "$189.00". */
export function formatMoney(cents, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
}
//# sourceMappingURL=money.js.map